export default __webpack_public_path__ + "static/media/cross-nft.ef6228b4.svg";